module.exports = [
	{
		"fund_family_label": "Vanguard",
		"net_assets": 7350354467153,
		"asset_rank": 1,
		"num_funds": 116,
		"sri": 6,
		"gef_num_funds": 114,
		"gef_score_norm": 53.784241242361134,
		"gef_score": 52.03984263405055,
		"gef_score_rank": 4,
		"dei_num_funds": 96,
		"dei_score_norm": 33.74698915657896,
		"dei_score": 28.226884033202243,
		"dei_score_rank": 5,
		"rji_num_funds": 96,
		"rji_score_norm": 24.696808834347394,
		"rji_score": 21.119461760527056,
		"rji_score_rank": 4,
		"hrc_num_funds": 75,
		"hrc_score_norm": 88.22426695735265,
		"hrc_score": 84.85129974764585,
		"hrc_score_rank": 4,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"net_assets": 3046922980865,
		"asset_rank": 2,
		"num_funds": 362,
		"sri": 31,
		"gef_num_funds": 342,
		"gef_score_norm": 53.587200919091856,
		"gef_score": 52.641834319908185,
		"gef_score_rank": 5,
		"dei_num_funds": 274,
		"dei_score_norm": 34.08955356888633,
		"dei_score": 29.45735906878696,
		"dei_score_rank": 3,
		"rji_num_funds": 274,
		"rji_score_norm": 24.624291897997278,
		"rji_score": 22.013384391299308,
		"rji_score_rank": 5,
		"hrc_num_funds": 236,
		"hrc_score_norm": 89.5078741796708,
		"hrc_score": 87.26286267767732,
		"hrc_score_rank": 2,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"net_assets": 2663146445619,
		"asset_rank": 3,
		"num_funds": 353,
		"sri": 47,
		"gef_num_funds": 301,
		"gef_score_norm": 52.93537697643649,
		"gef_score": 52.84339730984219,
		"gef_score_rank": 8,
		"dei_num_funds": 224,
		"dei_score_norm": 31.62632350216379,
		"dei_score": 29.088962272392504,
		"dei_score_rank": 9,
		"rji_num_funds": 224,
		"rji_score_norm": 23.080913763188487,
		"rji_score": 20.902659813227356,
		"rji_score_rank": 9,
		"hrc_num_funds": 180,
		"hrc_score_norm": 86.63441898553074,
		"hrc_score": 86.0029942504643,
		"hrc_score_rank": 8,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"net_assets": 2374578274092,
		"asset_rank": 4,
		"num_funds": 52,
		"sri": 0,
		"gef_num_funds": 50,
		"gef_score_norm": 55.134963503714964,
		"gef_score": 55.16753881922763,
		"gef_score_rank": 1,
		"dei_num_funds": 42,
		"dei_score_norm": 36.40699310062221,
		"dei_score": 35.54609922939307,
		"dei_score_rank": 1,
		"rji_num_funds": 42,
		"rji_score_norm": 25.22272495544067,
		"rji_score": 24.97744399944614,
		"rji_score_rank": 2,
		"hrc_num_funds": 40,
		"hrc_score_norm": 89.62365685329861,
		"hrc_score": 89.4301682437846,
		"hrc_score_rank": 1,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "State Street",
		"net_assets": 1311722483448,
		"asset_rank": 5,
		"num_funds": 120,
		"sri": 6,
		"gef_num_funds": 110,
		"gef_score_norm": 54.12611220658015,
		"gef_score": 50.88456044234649,
		"gef_score_rank": 2,
		"dei_num_funds": 95,
		"dei_score_norm": 35.78272672496723,
		"dei_score": 25.638405234955258,
		"dei_score_rank": 2,
		"rji_num_funds": 95,
		"rji_score_norm": 25.223980783929218,
		"rji_score": 18.655408566048084,
		"rji_score_rank": 1,
		"hrc_num_funds": 71,
		"hrc_score_norm": 87.57075131412608,
		"hrc_score": 81.23857316608276,
		"hrc_score_rank": 6,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Invesco",
		"net_assets": 780585533003,
		"asset_rank": 6,
		"num_funds": 205,
		"sri": 14,
		"gef_num_funds": 190,
		"gef_score_norm": 52.22339616608806,
		"gef_score": 49.8308799133508,
		"gef_score_rank": 9,
		"dei_num_funds": 170,
		"dei_score_norm": 33.94248307008375,
		"dei_score": 23.564810688409043,
		"dei_score_rank": 4,
		"rji_num_funds": 170,
		"rji_score_norm": 24.802238530007376,
		"rji_score": 17.707835069265656,
		"rji_score_rank": 3,
		"hrc_num_funds": 121,
		"hrc_score_norm": 86.5356702527437,
		"hrc_score": 80.50064708885473,
		"hrc_score_rank": 9,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"net_assets": 745402184996,
		"asset_rank": 7,
		"num_funds": 105,
		"sri": 1,
		"gef_num_funds": 96,
		"gef_score_norm": 53.08955068756553,
		"gef_score": 52.36146343655913,
		"gef_score_rank": 7,
		"dei_num_funds": 85,
		"dei_score_norm": 32.66703904986215,
		"dei_score": 29.97989231828711,
		"dei_score_rank": 7,
		"rji_num_funds": 85,
		"rji_score_norm": 24.13109541755116,
		"rji_score": 21.968252331262654,
		"rji_score_rank": 6,
		"hrc_num_funds": 69,
		"hrc_score_norm": 88.04952835410774,
		"hrc_score": 86.85956223812542,
		"hrc_score_rank": 5,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"net_assets": 684600000020,
		"asset_rank": 8,
		"num_funds": 11,
		"sri": 0,
		"gef_num_funds": 11,
		"gef_score_norm": 53.123951428133296,
		"gef_score": 53.57147093339868,
		"gef_score_rank": 6,
		"dei_num_funds": 10,
		"dei_score_norm": 31.690319793421125,
		"dei_score": 30.431857798448267,
		"dei_score_rank": 8,
		"rji_num_funds": 10,
		"rji_score_norm": 23.167142563920375,
		"rji_score": 22.464520692705673,
		"rji_score_rank": 8,
		"hrc_num_funds": 8,
		"hrc_score_norm": 89.25386962260637,
		"hrc_score": 88.36648706740453,
		"hrc_score_rank": 3,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "Schwab Funds",
		"net_assets": 571066493476,
		"asset_rank": 9,
		"num_funds": 63,
		"sri": 1,
		"gef_num_funds": 60,
		"gef_score_norm": 53.80300422063175,
		"gef_score": 52.73998894765497,
		"gef_score_rank": 3,
		"dei_num_funds": 50,
		"dei_score_norm": 32.78080183069533,
		"dei_score": 29.54851012814757,
		"dei_score_rank": 6,
		"rji_num_funds": 50,
		"rji_score_norm": 23.482468348222543,
		"rji_score": 21.912016694141872,
		"rji_score_rank": 7,
		"hrc_num_funds": 39,
		"hrc_score_norm": 87.4419615918473,
		"hrc_score": 87.72616891580803,
		"hrc_score_rank": 7,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 928
// module chunks = 0